import { BackButton, PlusButton } from "components/buttons";

import "./ComboHeader.scss";

export const ComboHeader = (props: {
  back: string;
  text: string;
  onAdd?: () => void;
}): JSX.Element => {
  return (
    <div className="comboHeader">
      <BackButton link={props.back} />

      <h2 className="header">{props.text}</h2>

      {props.onAdd && <PlusButton
        onClick={props.onAdd}
      />}
    </div>
  );
};
